export default "__VITE_ASSET__3F3CQk3e__"